import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    usedDays: number;
    maxDays?: number;
};

const ApartmentsCardChart: FC<Props> = ({ usedDays, maxDays }) => {
    const { t } = useTranslation();

    const radius = 22;
    const stroke = 2.5;
    const normalizedRadius = radius - stroke / 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const progress = maxDays ? usedDays / maxDays : 1;
    const strokeDashoffset = circumference - progress * circumference;
    const daysLeft = maxDays ? maxDays - usedDays : 0;

    return (
        <div className="relative flex items-center justify-center">
            <svg
                height={radius * 2}
                width={radius * 2}
                fill="transparent"
                className="rotate-[-90deg]"
            >
                <circle
                    stroke="#EAEAEA"
                    fill="inherit"
                    strokeWidth={stroke}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                />
                {maxDays && (
                    <circle
                        stroke="var(--color-primary-color)"
                        fill="inherit"
                        strokeWidth={stroke}
                        strokeLinecap="round"
                        strokeDasharray={circumference + ' ' + circumference}
                        strokeDashoffset={strokeDashoffset}
                        r={normalizedRadius}
                        cx={radius}
                        cy={radius}
                    />
                )}
            </svg>
            <div className="absolute text-center">
                <div className="text-xs leading-3">{daysLeft}</div>
                <div className="text-[0.625rem] text-popover-600 leading-3">
                    {t('main.apartments.components.chart.days')}
                </div>
            </div>
        </div>
    );
};

export default ApartmentsCardChart;
